const cls = "w-full bg-black border border-[#C9A227]/25 focus:border-[#C9A227] rounded-sm px-3 py-2.5 text-sm text-white outline-none transition-colors";

const F = ({ label, k, value, onChange, testid, span }) => (
  <label className={`block ${span ? "sm:col-span-2" : ""}`}>
    <span className="text-[10px] font-mono-ps uppercase tracking-widest text-[#9CA3AF]">{label}</span>
    <input data-testid={testid} value={value[k] || ""} onChange={(e) => onChange({ ...value, [k]: e.target.value })} className={`${cls} mt-1`} />
  </label>
);

export const EMPTY_INVOICE = { company_name: "", tax_code: "", vat_number: "", address: "", zip: "", city: "", province: "", ei_code: "", pec: "" };

export const invoiceValid = (raw) => {
  const v = Object.fromEntries(Object.entries(raw).map(([k, x]) => [k, (x || "").trim()]));
  return Boolean(v.company_name && v.address && v.zip && v.city && (v.tax_code || v.vat_number) && (!v.vat_number || v.ei_code || v.pec));
};

export const InvoiceFields = ({ enabled, setEnabled, value, onChange }) => (
  <div className="mt-4 border border-[#C9A227]/20 rounded-sm p-4">
    <label className="flex items-center gap-3 cursor-pointer">
      <input type="checkbox" data-testid="ck-wants-invoice" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} className="accent-[#C9A227] w-4 h-4" />
      <span className="text-sm text-white">Voglio la fattura elettronica</span>
    </label>
    <p className="text-xs text-[#9CA3AF] mt-1 ml-7">A tutti inviamo comunque la ricevuta PDF via email quando confermiamo il pagamento.</p>
    {enabled && (
      <div className="grid sm:grid-cols-2 gap-3 mt-4">
        <F label="Nome e cognome / Ragione sociale" k="company_name" value={value} onChange={onChange} testid="inv-company" span />
        <F label="Codice fiscale" k="tax_code" value={value} onChange={onChange} testid="inv-tax-code" />
        <F label="Partita IVA (se azienda)" k="vat_number" value={value} onChange={onChange} testid="inv-vat" />
        <F label="Indirizzo di fatturazione" k="address" value={value} onChange={onChange} testid="inv-address" span />
        <F label="CAP" k="zip" value={value} onChange={onChange} testid="inv-zip" />
        <F label="Città" k="city" value={value} onChange={onChange} testid="inv-city" />
        <F label="Provincia (es. MI)" k="province" value={value} onChange={onChange} testid="inv-province" />
        <F label="Codice destinatario SDI" k="ei_code" value={value} onChange={onChange} testid="inv-ei-code" />
        <F label="PEC" k="pec" value={value} onChange={onChange} testid="inv-pec" span />
        <p className="sm:col-span-2 text-[11px] text-[#6B7280]">Privati: basta il codice fiscale. Aziende: P.IVA + codice destinatario SDI oppure PEC.</p>
      </div>
    )}
  </div>
);
